/**
 * /dashboard/change-requests/new — New change-request page (G7.5). Any
 * authed tenant user can submit.
 *
 * The actual form lives in ChangeRequestForm (radio + per-type fields +
 * file inputs); this page only provides the shell + back link.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/change-requests/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { ChangeRequestForm } from "@/components/change-requests/change-request-form";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/change-requests/new",
)({
  component: NewChangeRequestRoute,
});

function NewChangeRequestRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <>
      <PageHeader
        title="New change request"
        description="Submit a change to your address or bank account. HR reviews and approves."
        actions={
          <Button asChild variant="outline" className="gap-1.5">
            <Link to="/app/$tenantSlug/change-requests" params={{ tenantSlug }}>
              <ArrowLeft aria-hidden className="h-4 w-4" />
              Back
            </Link>
          </Button>
        }
      />
      <ChangeRequestForm />
    </>
  );
}
